import React from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = ({ className = '' }) => {
  const { currentLocale, availableLocales, changeLanguage, getLanguageName, isLoading, t } = useLanguage();

  const handleLanguageChange = (event) => {
    const locale = event.target.value;
    if (locale !== currentLocale && !isLoading) {
      changeLanguage(locale);
    }
  };

  return (
    <label className={`language-selector ${className}`.trim()}>
      <Globe className="language-selector-icon" aria-hidden="true" />
      <select
        value={currentLocale}
        onChange={handleLanguageChange}
        disabled={isLoading}
        aria-label={t('common.language')}
      >
        {availableLocales.map((locale) => (
          <option key={locale} value={locale}>{getLanguageName(locale)}</option>
        ))}
      </select>
      <ChevronDown className="language-selector-chevron" aria-hidden="true" />
    </label>
  );
};

export default LanguageSelector;
